import styled from '@emotion/styled';
import SideBarItem from './SideBarItem';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../../hooks/user';
import { navItems } from '../../config';

export default function SideBar() {
  const location = useLocation();
  const pathname = location.pathname;
  const user = useUser();

  return (
    <Root>
      {navItems
        .filter((item) => {
          if (!item.roles?.length) {
            return true;
          }
          if (!user?.role) {
            return false;
          }
          return item.roles.includes(user?.role);
        })
        .map((item) => {
          const selected = pathname.startsWith(item.path);
          return (
            <SideBarItem
              key={item.path}
              icon={item.icon}
              path={item.path}
              selected={selected}
              title={item.title}
            />
          );
        })}
    </Root>
  );
}

const Root = styled.div`
  min-width: 200px;
  border-right: 1px solid;
  border-right-color: ${({ theme }) => theme.palette.divider};
  display: flex;
  flex-direction: column;
  /* align-items: flex-start; */
`;
